import { render, staticRenderFns } from "./ExpenseCategoryListPage.vue?vue&type=template&id=ef3039ee&"
import script from "./ExpenseCategoryListPage.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategoryListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports